/**
 * Tools reading time
 */
function toolsReadingTime() {
	const readingTimeEl = document.querySelector('.top .top-length span');
	if (!readingTimeEl) return;

	const averageWordsPerMinute = 180;

	const countWords = (text) => {
		return text.trim().split(/\s+/).filter(Boolean).length;
	};

	const getCleanText = () => {
		const mainEl = document.querySelector('main');
		if (!mainEl) return '';

		const clone = mainEl.cloneNode(true);

		const selectorsToRemove = ['script', 'style', 'noscript', '[aria-hidden="true"]'];
		clone.querySelectorAll(selectorsToRemove.join(',')).forEach(el => el.remove());

		return clone.textContent || '';
	};

	const text = getCleanText();
	const wordCount = countWords(text);

	const readingTimeMinutes = Math.ceil(wordCount / averageWordsPerMinute);

	readingTimeEl.textContent = readingTimeMinutes;
}

